
const findCircularField = (obj: any, path = '', seen = new WeakSet()): string | null => {
  if (obj !== null && typeof obj === 'object') {
    if (seen.has(obj)) return path
    if (typeof Element !== 'undefined' && (obj instanceof Element || obj instanceof EventTarget)) {
      return path || '(root)'
    }
    if (obj.constructor?.name?.includes('Element') || obj.constructor?.name?.includes('EventTarget')) {
      return path || '(root)'
    }
    seen.add(obj)
    for (const key of Object.keys(obj)) {
      const result = findCircularField(obj[key], path ? `${path}.${key}` : key, seen)
      if (result !== null) return result
    }
    seen.delete(obj)
  }
  return null
}

export const persistentSave = (key: string, data: any) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(data))
  } catch (e) {
    const field = findCircularField(data)
    console.error(`persistentSave(${key}): Cannot serialize form values. Non-serializable value found at field: "${field}"`, e)
  }
}

export const persistentDelete = (key: string) => {
  window.localStorage.removeItem(key)
}

export type GenericStorageRetrieveFn<T> = (key: string) => T | null

export function persistentGet<T>(key: string): T | null {
  const getResult = window.localStorage.getItem(key)
  return getResult ? JSON.parse(getResult) : null
}

export function persistentGetOrDefault<T>(key: string, defaultVal: T): T {
  const items = localStorage.getItem(key);
  if(items){
    return JSON.parse(items)
  }
  return defaultVal;
}

export const persistentDeleteMessage = (id: string) => {
  const items = persistentGetOrDefault<any>('socketMessages', []);
  const filtered = items.filter((item: any) => item.id !== id);
  persistentSave('socketMessages', filtered);
}

export const persistentAddMessage = (item: any) => {
  const items = persistentGetOrDefault<any[]>('socketMessages', []);
  items.unshift(item);
  persistentSave('socketMessages', items);
}